import { Injectable } from '@angular/core';

@Injectable()
export class DataFormatService {

    formatAccountLists(account_list_data: Array<any>): Array<any> {
        let account_lists: Array<any> = [];
        let accounts = JSON.parse(JSON.stringify(account_list_data));

        account_list_data.filter((acct: any) => acct.aa_id != null).forEach((acct: any) => {
            if (acct.acct_uacs_code.length == 10 && acct.acct_uacs_code.substring(acct.acct_uacs_code.length - 2) != "00") {
                let header = account_list_data.filter((ac: any) => (ac.acct_uacs_code.substring(0, ac.acct_uacs_code.length - 3) == acct.acct_uacs_code.substring(0, acct.acct_uacs_code.length - 3)) && ac.acct_uacs_code.substring(acct.acct_uacs_code.length - 3) == "000")[0];
                if (header != undefined) {
                    accounts.filter((ac: any) => ac.aa_id == acct.aa_id)[0].acct_title = `${acct.acct_title} (${header.acct_title})`;
                }
            }
            if (acct.acct_uacs_code.length == 14) {
                let prj = account_list_data.filter((ac: any) => (ac.acct_uacs_code.substring(0, 5) == acct.acct_uacs_code.substring(0, 5)) && ac.acct_uacs_code.substring(5, 7) == "00")[0];
                if (prj != undefined) {
                    accounts.filter((ac: any) => ac.aa_id == acct.aa_id)[0].acct_title = `${acct.acct_title} (${prj.acct_title})`;
                }
            }
        });

        account_lists = accounts.filter((accts: any) => accts.aa_id != null);
        // console.log('account_lists:', account_lists);
        return account_lists;
    }

}
